/**
 * Returns the minimum date (first day of the month, 5 years ago from now).
 */
export function getMinDate(): Date {
    const now = new Date();
    return new Date(now.getFullYear() - 5, now.getMonth(), 1);
  }
  
  /**
   * Returns the maximum date (first day of last month).
   */
  export function getMaxDate(): Date {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth() - 1, 1);
  }

/**
 * Returns the date for the first day of the month, N months before the provided base month.
 * If no base date is provided, uses the current month.
 * @param monthsAgo Number of months to subtract from the current month (default: 13)
 * @param baseDate Base month to subtract from (default: current date)
 */
export function getDefaultStartMonth(monthsAgo: number = 13, baseDate: Date = new Date()): Date {
  return new Date(baseDate.getFullYear(), baseDate.getMonth() - monthsAgo, 1);
}